import { OnboardingInfoDto } from '@interfaces/models';
import { PropsWithChildren, FC } from 'react';
import { Topbar } from '@shared/components';
import { Card, Logo } from '@ui/components';
import { Routes } from '@shared/enums';
import { cn } from '@ui/utils';

import { OnboardingStepper } from './onboarding-stepper/onboarding-stepper';
import { LanguagePicker } from './language-picker/language-picker';
import { OnboardingHelp } from './onboarding-help/onboarding-help';

const MODAL_STEPS = [Routes.FINISH];
const FULL_WIDTH_STEPS = [Routes.IMPORT_VEHICLES, Routes.IMPORT_EMPLOYEES];

type OnboardingLayoutProps = OnboardingInfoDto & PropsWithChildren;

export const OnboardingLayout: FC<OnboardingLayoutProps> = ({ children, ...props }) => {
  const isFullWidthStep = FULL_WIDTH_STEPS.some((route) => location.pathname.includes(route));
  const isModalStep = MODAL_STEPS.some((route) => location.pathname.includes(route));

  return (
    <main className="h-screen bg-cover bg-[url('../images/background.svg')] w-full overflow-auto">
      <Topbar />

      <header className="flex px-12 pt-4 h-14 items-center justify-between w-full">
        <Logo />
        <div className="ml-auto flex gap-4">
          <LanguagePicker />
          <OnboardingHelp />
        </div>
      </header>

      <div
        className={cn('mx-auto mt-10 pb-4 px-4 container', {
          'grid grid-cols-12 gap-6': !isModalStep,
          'w-full max-w-[800px]': isModalStep,
        })}
      >
        <Card className={cn('p-6 col-span-12 md:col-span-3 h-fit', { hidden: isModalStep })}>
          <OnboardingStepper {...props} />
        </Card>
        <Card
          className={cn('w-full p-6 h-fit', {
            'col-span-12 md:col-span-9 lg:col-span-7': !isModalStep,
            'lg:col-span-9': isFullWidthStep,
          })}
        >
          {children}
        </Card>
      </div>
    </main>
  );
};
